'use strict';

export { default as ReportingCurrencyReportTable } from './reportingCurrencyReportTable';